import React, { useState } from 'react';

export default function DatePicker({ value, onChange, placeholder, wrapperStyle }) {
  const [borderColor, setBorderColor] = useState('#E5E7EB');

  return (
    <div style={{ marginBottom: 14, ...wrapperStyle }}>
      <input
        type="date"
        value={value || ''}
        onChange={e => onChange(e.target.value)}
        onFocus={() => setBorderColor('#059669')}
        onBlur={() => setBorderColor('#E5E7EB')}
        style={{
          width:       '100%',
          padding:     '10px 14px',
          border:      `1px solid ${borderColor}`,
          borderRadius: 12,
          fontSize:    15,
          fontFamily:  'inherit',
          color:       value ? '#1E3A5F' : '#9CA3AF',
          background:  'white',
          cursor:      'pointer',
          outline:     'none',
          direction:   'ltr',
          boxSizing:   'border-box',
        }}
      />
    </div>
  );
}
